import { render, staticRenderFns } from "./ListUnverifiedUser.vue?vue&type=template&id=ad87aefa&scoped=true&lang=html"
import script from "./ListUnverifiedUser.vue?vue&type=script&lang=js"
export * from "./ListUnverifiedUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad87aefa",
  null
  
)

export default component.exports